import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { render } from 'react-snapshot';
import './index.css';
import { Button } from 'reactstrap';
import { Container } from 'reactstrap';
import { Row } from 'reactstrap';
import { Col } from 'reactstrap';
import firebase from './firebase.js';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import ReactGA from 'react-ga';

function Nappi(props) {
  if (props.tyyppi == 'teksti') {
    return (
      <Button
        key={props.teksti}
        className="vastausnappi btn-light btn-block"
        onClick={props.onClick}
      >
        {props.teksti}
      </Button>
    )
  } else {
    return (
      <img
        src={props.teksti}
        className="vastauskuva"
        onClick={props.onClick}
      />
    )
  }
}

class ProsenttiTulos extends React.Component {

  constructor(props) {
    super(props);
    const tyypit = [
      'haahuilija',
      'huolehtija',
      'yllapitaja',
      'hyodyntaja',
      'sijoittaja',
      'seikkailija'];

    this.state = {
      kysytty: false,
      vastattu: false,
      prosentti: 0,
      ykkosTyyppi: tyypit[this.props.ykkonen],
    };
  }

  render() {
    if (this.state.vastattu) {
      return(
        <p>Kanssasi samanlainen metsäsuhde on {this.state.prosentti}%:lla vastaajista.</p>
      );
    } else {

      const fbRef = firebase.database().ref();

      fbRef.once("value", (snapshot) => {
        let kaikkiTyypit = 0;
        let tamaTyyppi = 1;
        console.log("once: "+this.state.ykkosTyyppi);
        snapshot.forEach((child) => {
          console.log(child.key+": "+child.val());
          kaikkiTyypit = kaikkiTyypit + Number(child.val());
          if (child.key == this.state.ykkosTyyppi) {
            // const updRef = firebase.database().ref(child.key);
            // updRef.set(Number(child.val())+1);
            tamaTyyppi = Number(child.val())+1;
          }
          /*
          child.forEach(function(subChild) {
            console.log(child.key+"> "+subChild.key+" - "+subChild.val());
          //  if (child.key == ykkosTyyppiNimi) {
              console.log("ykkos: "+ykkosTyyppiNimi+" löytyi, update");
              const updRef = firebase.database().ref(child.key);
              updRef.set(1);
          //  }
          })
          */

        });
        kaikkiTyypit = kaikkiTyypit + 1; // lisätään nykyinen vastaus totaliin

        const prosentti = Math.floor(100.0*tamaTyyppi/kaikkiTyypit);

        console.log("Total: "+tamaTyyppi+"/"+kaikkiTyypit+": "+prosentti);
        this.setState({prosentti: prosentti, vastattu: true});

        // console.log('dbssa: '+snapshot.val());
      });
      //this.setState({kysytty: true});


      return(
        <p></p>
      );
    }
  }
}

class MetsaTesti extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      kysymykset: [
        {},
        {k: 'Metsässä',
          t:'teksti',
          v:[
            'kerään marjoja ja sieniä',
            'otan selfien',
            'tutkin luontoa',
            'on sijoitusmahdollisuuksia',
            'haen mielenrauhaa'],
          p:[
            [ 0,1,0,0,0,0 ],
            [ 1,0,0,0,0,1 ],
            [ 0,0,0,1,0,0 ],
            [ 0,0,0,0,1,0 ],
            [ 0,0,1,0,0,0 ]]},
        {k: 'Puiden halaaminen on',
          t:'teksti',
          v:[
            'ihanaa!',
            'ihan tyhmää'],
          p:[
            [1,1,1,0,0,0],
            [0,0,0,1,1,1]]},
        {k: 'Menen metsään',
          t:'teksti',
          v:[
            'yksin. Oma seura paras seura.',
            'yhdessä! Sharing is caring!'],
          p:[
            [0,0,0,1,1,1],
            [1,1,1,0,0,0]]},
        {k: 'Saan kutsun metsäfestareille,',
          t:'teksti',
          v:[
            'kieltäydyn kohteliaasti',
            'aloitan pakkaamisen välittömästi'],
          p:[
            [0,0,1,1,1,0],
            [1,1,0,0,0,1]]},
        {k: 'Ajattelen olevani',
          t:'teksti',
          v:[
            'harkitseva ja suunnitelmallinen',
            'hetkessä eläjä'],
          p:[
            [ 0,0,1,1,1,0 ],
            [ 1,1,0,0,0,1 ]]},
        {k: 'Juhlissa',
          t:'teksti',
          v:[
            'pidän puheen ja laulan karaokea',
            'viihdyn parhaiten lähimpien ystävieni seurassa',
            'haluaisin lähteä jo kotiin'],
          p:[
            [ 1,0,0,0,0,1 ],
            [ 0,1,0,0,1,0 ],
            [ 0,0,1,1,0,0 ]]},
        {k: 'Kun joogaan metsässä',
          t:'teksti',
          v:[
            'teen sen kavereiden kanssa metsäjoogakurssilla',
            'teen sen perheen metsäretkellä eväspaikalla lammen rannalla',
            'en todellakaan joogaa, paitsi ehkä salaa, yksin'],
          p:[
            [ 1,0,0,0,0,0 ],
            [ 0,1,1,0,0,0 ],
            [ 0,0,0,1,1,1 ]]},
        {k: 'Omistan metsää (jos omistaisin)',
          t:'teksti',
          v:[
            'ja hoidan sitä huolella',
            'rahan takii',
            'metsän itsensä vuoksi',
            'Ai omistanko? Missä?',
            'meille kaikille yhteiseksi rentoutumispaikaksi',
            'tein sinne reitin polkujuoksuun ja maastopyöräilyyn'],
          p:[
            [ 0,0,0,2,0,0 ],
            [ 0,0,0,0,2,0 ],
            [ 0,0,2,0,0,0 ],
            [ 2,0,0,0,0,0 ],
            [ 0,2,0,0,0,0 ],
            [ 0,0,0,0,0,2 ]]},
        {k: 'Mielestäni metsiä tulisi käyttää',
          t:'teksti',
          v:[
            'luonnonsuojelu edellä, metsä on pyhä paikka',
            'suorituspaikkana, metsä on oiva paikka kokea vauhtia ja vaarallisia tilanteita',
            'sijoituskohteena, se tuo taloudellista turvaa niin minulle kuin yhteiskunnallekin',
            'taloudellisesti. Myös luonnonsuojelu ja virkistyskäyttö pitää huomioida',
            'kunhan suojelustakin huolehditaan ja lähimetsä säilyy virkistäytymispaikkana arjessa',
            'mutta miten? Ei minulla oikeastaan ole mielipidettä metsien käytöstä'],
          p:[
            [ 0,0,2,0,0,0 ],
            [ 0,0,0,0,0,2 ],
            [ 0,0,0,0,2,0 ],
            [ 0,0,0,2,0,0 ],
            [ 0,2,0,0,0,0 ],
            [ 2,0,0,0,0,0 ]]},
        {k: 'Lähimetsän polulla',
          t:'teksti',
          v:[
            'tulee hiki ja saa haastaa itsensä',
            'kasvaa puita, joista voisi saada tuloja',
            'mieli ja sielu lepää arjen keskellä'],
          p:[
            [ 0,0,0,0,0,1 ],
            [ 0,0,0,1,1,0 ],
            [ 1,1,1,0,0,0 ]]},
        {k: 'Valitse itseäsi eniten ilahduttava kuva',
          t:'kuva',
          v:[
            'suojelualue.jpg',
            'metsapolku.jpg',
            'talousmetsa.jpg',
            'marjametsa.jpg'],
          p:[
            [ 0,0,1,0,0,0 ],
            [ 1,0,0,0,0,1 ],
            [ 0,0,0,1,1,0 ],
            [ 1,1,0,0,0,0 ]]},
        {k: 'Kaupan rekissä roikkuu hienon värinen tekninen vaate, juuri sopiva metsäretkille. Mitä mietit?',
          t:'teksti',
          v:[
            'Tarvitsenkohan tätä todella?',
            'Tämä on hankittava, jos se on kotimainen',
            'Tällainen minulla oli aikaisemminkin, se toimi hyvin, hankin uuden samanlaisen',
            'Hyperpaikallisesti tuotetta ja hei, mun naapuri on ollut designaamassa tätä!',
            'Laatu ennen hintaa, näyttää hyvin valmistetulta ja istuvalta',
            'Viimeistä teknologiaa, pakko kokeilla!'],
          p:[
            [ 0,0,2,0,0,0 ],
            [ 0,2,0,0,0,0 ],
            [ 0,0,0,2,0,0 ],
            [ 2,0,0,0,0,0 ],
            [ 0,0,0,0,2,0 ],
            [ 2,0,0,0,0,2 ]]},
        {k: 'Tulevaisuudessa metsä on',
          t:'teksti',
          v:[
            'täynnä yllätyksellisyyttä ja innovaatioita',
            'keskeinen osa suomalaisuutta',
            'yhteiskunnan ja minun turva',
            'toivottavasti olemassa'],
          p:[
            [ 1,0,0,0,0,1 ],
            [ 0,1,1,0,0,0 ],
            [ 0,0,0,1,1,0 ],
            [ 0,0,1,0,0,0 ]]},
      ],
      nykyinen: 0,
      vastaukset: Array(14).fill(null),
      tyypitNimi: [
                    'huoleton haahuilija',
                    'yhteisöllinen huolehtija',
                    'seesteinen ylläpitäjä',
                    'harkitseva hyödyntäjä',
                    'määrätietoinen sijoittaja',
                    'energinen seikkailija'],
      tyypitTeksti: [
        'Sinulle metsä on hauska ja huoleton vapaa-ajanviettopaikka siinä missä vaikkapa aurinkoinen hiekkaranta kesällä. Menet metsään mieluiten kaveriporukassa. Et ehkä ole kovin perillä metsätaloudesta etkä juurikaan pohdi taloudellisia tai luonnonsuojelullisia seikkoja metsässä käyskennellessäsi. Ihmisenä olet spontaani ja herkästi innostuva ja sama pätee suhteessasi metsään. Päämäärätön ”haahuilu” kuvaa hyvin sitä, mitä mieluiten teet metsässä ja totta kai jaat kokemuksesi somessa.',
        'Sinulla on erityisen lämmin suhde lähimetsän kanssa, se tarjoaa virkistäytymishetkiä arjessa. Samoilet metsässä mieluiten läheisten ystävien tai perheen kanssa. Nautit erityisesti sienimetsässä ja marjoja poimiessasi.  Virkistäydyt myös piipahtamalla metsässä koiran kanssa. Mielestäsi metsien taloudellinen hyödyntäminen on hyväksyttyä, kunhan metsäluonnon suojeleminenkin otetaan vakavasti.',
        'Metsä on sinulle pyhä paikka ja keskeinen osa suomalaisuutta. Arvostat metsää metsän itsensä vuoksi ja siksi metsän ja sen suojeleminen sekä virkistyskäyttö ovat sinulle erittäin tärkeitä. Menet metsään yksin, lähimpien ystävien tai perheenjäsenten kanssa. Parhaiten viihdyt monimuotoisessa luonnontilaisessa metsässä. Yhteydessä koskemattomaan luontoon sielu lepää ja mieli rauhoittuu.',
        'Metsät tarjoavat työtä ja toimeentuloa ja ovat ne toki myös paikka virkistäytyä. Olet tarkka, harkitseva ja suunnitelmallinen ja myös metsän suhteen sinulla on homma aina hallussa. Sinä menet metsään mielellään yksin, et kaipaa välttämättä seuraa. Pidät metsätöiden tekemisestä ja mielesi lepää kohisten kasvavassa metsässä. Taloudelliset, suojelulliset ja virkistykselliset arvot ovat sinulle yhtä lailla tärkeitä.',
        'Metsä tuo ennen kaikkea taloudellista turvaa niin sinulle kuin yhteiskunnallekin. Suhteesi fyysiseen metsään saattaa olla hieman etäinen, suhteesi metsäomaisuuteesi on sen sijaan lämmin. Olet elämässä määrätietoinen ja myös metsään liittyy itsevarma, selkeä ja jopa hallitseva tunne. Metsään menet esimerkiksi lenkille tai metsästämään. Metsässä saat olla oma itsesi.',
        'Metsä on sinulle innovatiivinen ympäristö ja paikka suurelle seikkailulle. Suhteessa metsään olet kokeilunhaluinen ja rohkea. Pidät itsesi haastamisesta ja metsä on paikka kokea vauhtia ja vaarallisia tilanteita. Menet metsään mielellään seurassa ja jaat suorituksesi somessa. Mielestäsi metsä on myös monipuolinen luonnonvara, jonka kestävään käyttöön liittyy tulevaisuudessa lukemattomia mahdollisuuksia.'],
      tyypitTeksti2: [
        'Metsäalan ammattilaisena voisit olla muotoilija tai puurakentamiseen erikoistunut arkkitehti. Viihtyisit myös viestintään erikoistuneen metsänhoitajan tai metsätalousinsinöörin työssä.',
        'Metsäalan ammattilaisena voisit olla luonto-ohjaaja, metsäpedagogi, kaupunkimetsien ja virkistysalueiden hoitoon ja suunnitteluun erikoistunut metsänhoitaja tai metsätalousinsinööri.',
        'Metsäalan ammattilaisena voisit olla metsänhoitaja, luonto- ja ympäristöneuvoja tai vaikka arboristi.',
        'Metsäalan ammattilaisena voisit olla metsätalousinsinööri tai metsänhoitaja, joka tutkii metsiä ja suunnittelee niiden käyttöä. Mikset myös metsuri ja metsäpalvelujen tuottaja tai metsäkoneenkuljettaja.',
        'Metsäalan ammattilaisena voisit olla metsänhoitaja painottaen opinnoissasi ekonomiaa, puukauppaan erikoistunut metsätalousinsinööri tai vaikka prosessitekniikan diplomi-insinööri.',
        'Metsäalan ammattilaisena voisit olla mitä vaan; puuseppä, designeri, biotuoteinsinööri, trooppisten metsien tutkija tai vaikka metsäkoneen kuljettaja.'],
      tyypitKuva: [
        'haahuilija.jpg',
        'huolehtija.jpg',
        'yllapitaja.jpg',
        'hyodyntaja.jpg',
        'sijoittaja.jpg',
        'seikkailija.jpg']
    };
    if (props.tila == 'testi') {
      this.state.nykyinen = 1;
    }
//    console.log("---: "+props.tila);
    this.initializeReactGA();
  }

  initializeReactGA() {
    ReactGA.initialize('UA-129828880-1');
    ReactGA.pageview('/');
  }

  handleClick(i) {
    const vastaukset = this.state.vastaukset.slice();
    vastaukset[this.state.nykyinen] = i;
    this.setState({
      vastaukset: vastaukset,
      nykyinen: this.state.nykyinen+1,
    });
  }

  aloitaTesti() {
    this.setState({
      nykyinen: 1,
    });
  }

  render() {
    if (this.props.tila != 'tulos') {
      const kysymysNumero = this.state.nykyinen;
      const kysymyksiaYhteensa = this.state.kysymykset.length;

      if (kysymysNumero == 0) {
        // Alkutekstit
        return (
          <Row key="sisalto" className="mb-3 py-4 justify-content-center">
            <Col className="justify-content-center text-center col-sm-8">
              <h2>Jokaisella suomalaisella on suhde metsään.</h2>
              <p><a href="https://smy.fi/artikkeli/suomalaisen-metsasuhde-on-moniarvoinen-henkinen-ja-arkinen/">Selvityksen</a> mukaan 83 prosentille suomalaisista metsä on melko tai erittäin tärkeä. Metsäsuhteissamme on yhteisiä elementtejä kuten halu toimia luonnon hyväksi. Suomalaiset kokevat, että metsä poistaa stressiä ja siellä saa olla oma itsensä. Erojakin metsäsuhteistamme löytyy.</p>
              <p>Selvitä millainen on sinun metsäsuhteesi!</p>
              <br />
              <Button className="aloitusnappi btn-light" onClick={() => this.aloitaTesti()}>Aloita testi</Button>
              <br /><br />
            </Col>
          </Row>
        );
      } else if (kysymysNumero >= kysymyksiaYhteensa) {
        // Lopputulos

        // console.log(this.state.vastaukset);
        const tyyppiRanking = Array(6).fill(0);
        for (let i = 1; i < this.state.vastaukset.length; i++) {
          for (let j = 0; j < 6; j++) {
            // console.log(i+' '+j+': '+this.state.vastaukset[i][j]+" - "+tyyppiRanking);
            tyyppiRanking[j] = tyyppiRanking[j] + this.state.vastaukset[i][j];
          }
        }

        // console.log(tyyppiRanking);
        const tyypitAss = [];//Array(6).fill([]);
        for (let i = 0; i < 6; i++) {
          tyypitAss[i] = { tyyppi: i, pisteet: tyyppiRanking[i] };
        }

        console.log(tyypitAss);

        const topTyypit = [].concat(tyypitAss).sort((a, b) => a.pisteet - b.pisteet);
        //const topTyypit = tyypitAss.slice();//.sort((a, b) => a.pisteet < b.pisteet);

        let ykkosTyyppiNimi;
        switch (topTyypit[5].tyyppi) {
          case 0:
            ykkosTyyppiNimi = 'haahuilija';
            break;
          case 1:
            ykkosTyyppiNimi = 'huolehtija';
            break;
          case 2:
            ykkosTyyppiNimi = 'yllapitaja';
            break;
          case 3:
            ykkosTyyppiNimi = 'hyodyntaja';
            break;
          case 4:
            ykkosTyyppiNimi = 'sijoittaja';
            break;
          case 5:
            ykkosTyyppiNimi = 'seikkailija';
            break;
        }


        let kaikkiTyypit = 0;
        let tamaTyyppi = 1;

        const fbRef = firebase.database().ref();

        fbRef.once("value", (snapshot) => {
          console.log("once: "+ykkosTyyppiNimi);
          snapshot.forEach(function(child) {
            console.log(child.key+": "+child.val());
            kaikkiTyypit = kaikkiTyypit + Number(child.val());
            if (child.key == ykkosTyyppiNimi) {
              const updRef = firebase.database().ref(child.key);
              updRef.set(Number(child.val())+1);
              tamaTyyppi = Number(child.val())+1;
            }
            /*
            child.forEach(function(subChild) {
              console.log(child.key+"> "+subChild.key+" - "+subChild.val());
            //  if (child.key == ykkosTyyppiNimi) {
                console.log("ykkos: "+ykkosTyyppiNimi+" löytyi, update");
                const updRef = firebase.database().ref(child.key);
                updRef.set(1);
            //  }
            })
            */

          });

          // console.log('dbssa: '+snapshot.val());
        });

        kaikkiTyypit = kaikkiTyypit + 1; // lisätään nykyinen vastaus totaliin

        const prosentti = Math.floor(100.0*tamaTyyppi/kaikkiTyypit);

        console.log("Total: "+tamaTyyppi+"/"+kaikkiTyypit+": "+prosentti);

        return (
          <Redirect to={'/tulos/'+topTyypit[5].tyyppi+'/'+topTyypit[4].tyyppi+'/'+topTyypit[3].tyyppi} />
        );

      /*
      return (
            <>
            <Row key="sisaltoOtsikko" className="mb-0 pt-4 px-5 justify-content-center">
              <Col>
                <h2 className="oranssi">OLET {this.state.tyypitNimi[topTyypit[5].tyyppi].toUpperCase()},</h2>
              </Col>
            </Row>
            <Row key="sisalto" className="mb-3 pb-4 px-5 justify-content-center">

              <Col className="col-lg-9 col-md-6 col-12 order-2 order-md-1">
                <p><strong>mutta hieman myös {this.state.tyypitNimi[topTyypit[4].tyyppi]} ja {this.state.tyypitNimi[topTyypit[3].tyyppi]}</strong></p>
                <p>{this.state.tyypitTeksti[topTyypit[5].tyyppi]}</p>
                <p>{this.state.tyypitTeksti2[topTyypit[5].tyyppi]}</p>

                <p>Tutustu kaikkiin <a href="https://smy.fi/artikkeli/millainen-on-sinun-metsasuhteesi/">metsäsuhdetyyppeihin</a></p>
                <Button className="aloitusnappi btn-light" onClick={() => this.aloitaTesti()}>Tee testi uudelleen</Button>
              </Col>
              <Col className="mb-3 col-lg-3 col-md-6 order-1 order-md-2">
                <img src={this.state.tyypitKuva[topTyypit[5].tyyppi]} className="img-fluid w-100" alt="Responsive image" />
                <img src={'th-'+this.state.tyypitKuva[topTyypit[4].tyyppi].substring(0,this.state.tyypitKuva[topTyypit[4].tyyppi].length-4)+'.png'} className="ympyrakuva img-fluid" alt="Responsive image" />
                <img src={'th-'+this.state.tyypitKuva[topTyypit[3].tyyppi].substring(0,this.state.tyypitKuva[topTyypit[3].tyyppi].length-4)+'.png'} className="ympyrakuva img-fluid" alt="Responsive image" />
              </Col>
            </Row>
            </>
        );
      */

        } else {
          const kysymykset = this.state.kysymykset;
          const nykyinenKysymys = kysymykset[this.state.nykyinen];
          const kysymysTeksti = nykyinenKysymys.k;
          const vastausTekstit = nykyinenKysymys.v;
          const vastausPisteet = nykyinenKysymys.p;
          const kysymysTyyppi = nykyinenKysymys.t;

          let kysymysNapit;

          if (kysymysNumero == 1) {
            ReactGA.pageview('/testi');
          }
          ReactGA.event({
            category: 'Testi',
            action: 'kysymys'+kysymysNumero,
          })

          if (kysymysTyyppi == 'teksti') {
            kysymysNapit = vastausTekstit.map((vastaus, numero) => {
              return (

                <p key={numero}><Nappi
                  key={"btn-"+numero}
                  tyyppi={kysymysTyyppi}
                  onClick={() => this.handleClick(vastausPisteet[numero])}
                  teksti={vastaus}
                /></p>

              );
            });
        } else {
          kysymysNapit = vastausTekstit.map((vastaus, numero) => {
            let valitagi1, valitagi2;
            if (numero % 2) {
              return(
                <>
                <Nappi
                  key={"btn-"+numero}
                  tyyppi={kysymysTyyppi}
                  onClick={() => this.handleClick(vastausPisteet[numero])}
                  teksti={vastaus}
                  />
                <br />
                </>
              );

            } else {
              return(
                <Nappi
                  key={"btn-"+numero}
                  tyyppi={kysymysTyyppi}
                  onClick={() => this.handleClick(vastausPisteet[numero])}
                  teksti={vastaus}
                  />
              );

            }
          });
        }
        return(
          <Row key="sisalto" className="mb-3 py-4 justify-content-center">
            <Col className="justify-content-center text-center col-sm-8">
              <p>KYSYMYS {this.state.nykyinen}/13</p>
              <h2>{kysymysTeksti}</h2>

                {kysymysNapit}

            </Col>
          </Row>
        )

      }
    } else {
      const t1 = this.props.match.params.t1;
      let t2 = this.props.match.params.t2;
      let t3 = this.props.match.params.t3;

      if (t2 == undefined) {
        t2 = 1;
      }
      if (t3 == undefined) {
        t3 = 2;
      }

      console.log("search: "+this.props.match.params.t2);

      ReactGA.pageview('/tulos');

      return (
            <>
            <Row key="sisaltoOtsikko" className="mb-0 pt-4 px-5 justify-content-center">
              <Col>
                <h2 className="oranssi">OLET {this.state.tyypitNimi[t1].toUpperCase()},</h2>
              </Col>
            </Row>
            <Row key="sisalto" className="mb-3 pb-4 px-5 justify-content-center">

              <Col className="col-lg-9 col-md-6 col-12 order-2 order-md-1">
                <p><strong>mutta hieman myös {this.state.tyypitNimi[t2]} ja {this.state.tyypitNimi[t3]}</strong></p>
                <p>{this.state.tyypitTeksti[t1]}</p>
                <p>{this.state.tyypitTeksti2[t1]}</p>
                <ProsenttiTulos ykkonen={t1} />
                <p>Tutustu kaikkiin <a href="https://smy.fi/artikkeli/millainen-on-sinun-metsasuhteesi/">metsäsuhdetyyppeihin</a></p>
                <Button className="aloitusnappi btn-light" onClick={() => {window.location='http://www.facebook.com/sharer/sharer.php?u=http://metsasuhdetesti.fi/t'+t1+'.html'+encodeURIComponent('?t2='+t2+'&t3='+t3+'&')+'title=METSÄSUHDETESTI';} } >Jaa tulos Facebookissa</Button>
                <p><a href="/">Tee testi uudelleen</a></p>
              </Col>
              <Col className="mb-3 col-lg-3 col-md-6 order-1 order-md-2">
                <img src={'/'+this.state.tyypitKuva[t1]} className="img-fluid w-100" alt="Responsive image" />
                <img src={'/th-'+this.state.tyypitKuva[t2].substring(0,this.state.tyypitKuva[t2].length-4)+'.png'} className="ympyrakuva img-fluid" alt="Responsive image" />
                <img src={'/th-'+this.state.tyypitKuva[t3].substring(0,this.state.tyypitKuva[t3].length-4)+'.png'} className="ympyrakuva img-fluid" alt="Responsive image" />
              </Col>
            </Row>
            </>
        );
    }
  }
}


// ========================================

render(
  <Router>

    <Container>
      <Row key="otsalauta" className="p-0 mb-3">
        <Col className="p-0">
          <img src={"/tausta.jpg"} className="img-fluid w-100" alt="Responsive image" />
        </Col>
      </Row>


      <Route exact path="/" render={(props) => <MetsaTesti {...props} tila={'alku'} />} />
      <Route exact path="/testi" render={(props) => <MetsaTesti {...props} tila={'testi'} />} />
      <Route exact path="/tulos/:t1/:t2?/:t3?" render={(props) => <MetsaTesti {...props} tila={'tulos'} />} />


      <Row key="footer" className="py-4">
        <Col className="d-flex justify-content-center">
          <img src={"/smy-logo.png"} className="img-rounded center-block" alt="Responsive image" />
        </Col>
      </Row>
    </Container>
  </Router>
  ,
  document.getElementById('root')
);
